import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type { Error } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  shortErrorMessage?: string
  onError?: (error: Error) => void
  onSuccess?: () => void
  children?: () => ReactElement
}

const DeleteRequirementGroupRequest = ({
  id,
  shortErrorMessage,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/requirement_groups/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default DeleteRequirementGroupRequest
